import React from 'react';
import PageHeader from '../components/PageHeader';
import BeforeAfterSection from '../components/BeforeAfterSection';
import RecentWorkGallery from '../components/RecentWorkGallery';
import CTABoxes from '../components/CTABoxes';

const GalleryPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="Our Portfolio"
        title="Project / Portfolio"
        description="See the transformation — real projects, real results. Quality work that speaks for itself."
      />
      <BeforeAfterSection />
      <RecentWorkGallery />
      <CTABoxes />
    </>
  );
};

export default GalleryPage;
